var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-container"},[_c('import-client-data',{on:{"success":_vm.onSuccessfulImport}}),_c('el-row',{staticClass:"dialog-footer",attrs:{"gutter":18}},[_c('el-col',{staticClass:"align-right",attrs:{"span":24}},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("Close")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }